import React from "react";
import SubHeader from "../general/SubHeader";
import Sagar from "../../assets/member/SagarKataria.jpg";

const SagarKataria = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={Sagar}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">Sagar Kataria</p>
                <span>Event & Activities Manager</span>
                <br />

                <p className="mt-3">
                  Sagar Kataria is the Event & Activities Manager at Swalok
                  Group, where he plays a pivotal role in planning,
                  coordinating, and executing a wide range of events and
                  activities that align with the organization's goals. With a
                  keen eye for detail and a strong sense of creativity, Sagar
                  ensures that each event is thoughtfully curated and
                  meticulously organized to leave a lasting impact on
                  participants and stakeholders. His expertise lies in managing
                  both small-scale and large-scale events, including corporate
                  functions, conferences, team-building activities, and social
                  events, all while maintaining a high level of professionalism
                  and efficiency.
                  <br />
                  <br />
                  Sagar’s ability to collaborate with cross-functional teams,
                  vendors, and clients ensures smooth event execution, and his
                  problem-solving skills allow him to tackle any challenges that
                  arise. He brings a customer-focused approach to his work,
                  ensuring that each event meets the expectations of attendees
                  and contributes to the organization's branding and objectives.
                  <br />
                  <br />
                  <strong>
                    His attention to detail, proactive planning, and ability to
                    manage multiple tasks simultaneously make him an invaluable
                    asset to Swalok Group. Sagar Kataria continues to elevate
                    the organization’s events, strengthening relationships and
                    enhancing its public presence through engaging and
                    well-executed activities.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default SagarKataria;
